import mobile from "./_mobile";

interface MediaQueriesType {
    reduceMotion: boolean;
    highContrast: boolean;
    mobile: boolean;
}

const MediaQueries = <MediaQueriesType>{
    reduceMotion: window.matchMedia("(prefers-reduced-motion)").matches,
    highContrast: window.matchMedia("(prefers-contrast: more)").matches,
    mobile: mobile
}

export default MediaQueries;